import { POSTRequest } from "../../apiHandler"

export const handleIncomingQR = (data, settings) => new Promise((resolve, reject) => {
  POSTRequest("qr.php","QR_INCOMING",{qr_text : data, settings : settings})
    .then(response => resolve({...response, isQR :true}))
})